<script>
import BaseResource from '@/resources'
import Vue from 'vue'

export default Vue.extend({
    name: 'ResourceAttribute',
    props: {
        resource: {
            type: BaseResource,
            required: true,
        },
        attribute: {
            type: String,
            required: true,
        },
        prepend: {
            type: String,
            default: '',
        },
        append: {
            type: String,
            default: '',
        },
        loadingText: {
            type: String,
            default: 'Loading...',
        },
        default: {
            type: String,
            default: '(None)',
        },
        linked: Boolean,
    },
    data() {
        return {
            loading: true,
        }
    },
    computed: {
        value() {
            if (this.loading) return ''

            try {
                let value = this.resource.get(this.attribute)

                if (value === undefined) {
                    value = this.default
                }

                return this.prepend + value + this.append
            } catch (e) {
                if (String(e).match('resolve()')) {
                    this.resolveAttribute()
                    return ''
                }

                return '<error>'
            }
        },
    },
    watch: {
        resource(newValue, oldValue) {
            if (newValue.id !== oldValue.id) {
                this.resolveAttribute()
            }
        },
        attribute(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.resolveAttribute()
            }
        },
    },
    methods: {
        async resolveAttribute() {
            this.loading = true

            try {
                await this.resource.resolveAttribute(this.attribute)
            } catch (e) {
                console.log(e)
            }

            this.loading = false
        },
        onClick() {
            this.$emit('click')
        },
    },
    beforeMount() {
        this.resolveAttribute()
    },
})
</script>

<template>
    <span v-if="resource">
        <slot name="default" :value="value" :loading="loading" :resource="resource">
            <span v-if="!loading && linked" class="resource-attr">
                <a href="javascript:{}" @click.prevent="onClick">{{ value }}</a>
            </span>
            <span v-else-if="!loading" class="resource-attr" @click="onClick">
                {{ value }}
            </span>
            <span v-else class="text-muted"> {{ loadingText }} </span>
        </slot>
    </span>
</template>

<style lang="scss" scoped>

</style>
